import {Component, HostBinding, Input} from '@angular/core';
import {QuoteStatus} from '../../interfaces/quote';

/** A quote's status as one chip, the invoice chip's shape: the label carries the meaning, the dot the glance (#1698). */
@Component({
  selector: 'bst-quote-status',
  template: `<span class="dot" aria-hidden="true"></span>{{ 'quotes.status.' + status | translate }}`,
  styles: [`
    :host { display: inline-flex; align-items: center; gap: 6px; padding: 1px 9px 1px 8px; border: 1px solid transparent; border-radius: 999px;
      font-size: 0.75rem; font-weight: 600; line-height: 1.5; white-space: nowrap; vertical-align: middle; }
    .dot { width: 6px; height: 6px; border-radius: 50%; background: var(--dot); flex: none; }
    :host(.draft) { --dot: var(--color-warning-500); background: var(--color-warning-100); color: var(--color-warning-800); }
    :host(.submitted) { --dot: var(--color-info-500); background: var(--color-info-100); color: var(--color-info-700); }
    :host(.accepted) { --dot: var(--color-success-500); background: var(--color-success-100); color: var(--color-success-700); }
    :host(.rejected) { --dot: var(--color-danger-500); background: var(--color-danger-100); color: var(--color-danger-700); }
    :host(.expired) { --dot: var(--color-basic-600); background: var(--color-basic-200); color: var(--color-basic-700); }
    /* Replaced by a newer version: outlined, hollow dot. */
    :host(.superseded) { background: transparent; border-color: var(--color-basic-400); color: var(--color-basic-800); }
    :host(.superseded) .dot { background: none; box-shadow: inset 0 0 0 1.5px var(--color-basic-600); }
  `],
  standalone: false
})
export class QuoteStatusComponent {
  @Input({required: true}) @HostBinding('class') status: QuoteStatus;
}
